/**
 * @generated SignedSource<<ef11623e69968eee1d8492a798c2e0fc>>
 * @relayHash da2409ae2bc56c51b0f8898e8ba8c588
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7

import type { ConcreteRequest, Query } from 'relay-runtime';
export type srcFullCoreQuery$variables = {
  cloudId: string;
};
export type srcFullCoreQuery$data = {
  readonly jira: {
    readonly permission: {
      readonly hasPermission: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type srcFullCoreQuery = {
  response: srcFullCoreQuery$data;
  variables: srcFullCoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "BULK_CHANGE"
          }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcFullCoreQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcFullCoreQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7",
    "metadata": {},
    "name": "srcFullCoreQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8f533a407f873e189baff8b23fd6e216";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
